import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";

// Pages
import LoginPage from "./pages/LoginPage";
import BusinessPulseDashboard from "./pages/BusinessPulseDashboard";
import IntegrationsPage from "./pages/IntegrationsPage";
import UploadsPage from "./pages/UploadsPage";
import SalesExplorerPage from "./pages/SalesExplorerPage";
import SourceHealthPage from "./pages/SourceHealthPage";
import IntegrationCopilotPage from "./pages/IntegrationCopilotPage";
import ItemUploadsPage from "./pages/ItemUploadsPage";
import PartnerAdminPage from "./pages/PartnerAdminPage";
import SourceConfidencePage from "./pages/SourceConfidencePage";
import ServiceChargePage from "./pages/ServiceChargePage";
import DiscountsPage from "./pages/DiscountsPage";
import TableEfficiencyPage from "./pages/TableEfficiencyPage";
import SalesDecisionsPage from "./pages/SalesDecisionsPage";
import OutletSettingsPage from "./pages/OutletSettingsPage";

// Layout
import AppLayout from "./components/layout/AppLayout";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#09090B] flex items-center justify-center">
        <div className="text-zinc-400">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Routes>
                <Route path="/" element={<BusinessPulseDashboard />} />
                <Route path="/sales-decisions" element={<SalesDecisionsPage />} />
                <Route path="/integrations" element={<IntegrationsPage />} />
                <Route path="/uploads" element={<UploadsPage />} />
                <Route path="/items" element={<ItemUploadsPage />} />
                <Route path="/explorer" element={<SalesExplorerPage />} />
                <Route path="/service-charge" element={<ServiceChargePage />} />
                <Route path="/discounts" element={<DiscountsPage />} />
                <Route path="/operations/table-efficiency" element={<TableEfficiencyPage />} />
                <Route path="/settings/outlet" element={<OutletSettingsPage />} />
                <Route path="/health" element={<SourceHealthPage />} />
                <Route path="/copilot" element={<IntegrationCopilotPage />} />
                <Route path="/partners" element={<PartnerAdminPage />} />
                <Route path="/confidence" element={<SourceConfidencePage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </AppLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
